import React, { useState } from "react";
import { MenuItem } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getUserData } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import useResetStateByKey from "@icarius-utils/hooks/useResetStateByKey";
import Header from "./header";
import Form from "./form";

const Item = (props) => {
    const {
        data,
        isLoading,
        readOnly,
        isQuestion,
        handleUpdateQuestion,
        handleDeleteQuestion,
        handleUpdateAnswer,
        handleDeleteAnswer,
    } = props;

    const [formIsOpen, setFormIsOpen] = useState(false);

    const { key, resetState } = useResetStateByKey();

    const userData = useSelector(getUserData);
    const isOwner = userData.code === data.owner.code;

    const handleCloseForm = () => {
        setFormIsOpen(false);
        resetState();
    };

    return (
        <div
            style={{
                padding: 20,
                borderRadius: 10,
                background: "var(--tertiaryBackgroundColor)",
                border: "1px solid var(--borderColor)",
            }}
        >
            <Header
                image={data.owner.image}
                name={data.owner.name}
                date={data.date}
                time={data.time}
                edited={data.edited}
                hasMenu={!isLoading && !readOnly && isOwner}
                menuOptions={[
                    isOwner && !formIsOpen && (
                        <MenuItem key={1} onClick={() => setFormIsOpen(true)}>
                            {getLocalizedString("edit")}
                        </MenuItem>
                    ),
                    isOwner && (
                        <MenuItem key={3} onClick={isQuestion ? handleDeleteQuestion : handleDeleteAnswer}>
                            {getLocalizedString("delete")}
                        </MenuItem>
                    ),
                ]}
            />
            <div style={{ paddingTop: 10 }}>
                <Form
                    key={key}
                    isQuestion={isQuestion}
                    readOnly={!formIsOpen}
                    data={data}
                    handleUpdate={isQuestion ? handleUpdateQuestion : handleUpdateAnswer}
                    handleClose={handleCloseForm}
                />
            </div>
        </div>
    );
};

export default Item;
